import merge from 'deepmerge';
import _get from 'lodash/get';
import _pick from 'lodash/pick';

import programmatic from './programmatic';
import { environmentLanguageConfig } from './config';

import cs from './cs.yml';
import de from './de.yml';
import el from './el.yml';
import en from './en.yml';
import es from './es.yml';
import fi from './fi.yml';
import fr from './fr.yml';
import it from './it.yml';
import nl from './nl.yml';
import no from './no.yml';
import pl from './pl.yml';
import pt from './pt.yml';
import sv from './sv.yml';

const mergedTranslations = merge.all([
  programmatic,
  cs,
  de,
  el,
  en,
  es,
  fi,
  fr,
  it,
  nl,
  no,
  sv,
  pl,
  pt,
]);

const environment = _get(window, 'config.common.environment.type');

const supportedLanguages =
  environmentLanguageConfig[environment] || environmentLanguageConfig.default;

export default _pick(mergedTranslations, supportedLanguages);
